<template>
  <div class="absolute fill-height events-page">
    <v-dialog
      v-model="dialogUploadDocument"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogUploadDocument"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2 v-if="invoiceNeedsApproval">Nahrát fakturu ke spolupracovníkovi</h2>
          <h2 v-else>Nahrát fakturu ke spolupracovníkovi k odsouhlasení</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <vue-dropzone :options="dropzoneOptions" :id="'dropzone'" :useCustomSlot="true" style="min-height: 120px;">
            <v-card class="elevation-1" color="grey lighten-4 dropzone-clickable">
              <v-card-text class="pt-3 text-xs-left">
                <div>

                </div>
                <p class="pt-5 pb-4 text-xs-center">Nahrajte přetažením souboru z počítače</p>
              </v-card-text>
            </v-card>
          </vue-dropzone>
          <div hidden id="dropzone-preview"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogUploadDocument=false" :loading="uploading">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      persistent :overlay="false"
      transition="dialog-transition"
      max-width="400px"
    >
      <v-card>
        <v-card-text class="text-xs-center">
          <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null && !success" class="mt-5 mb-2"></v-progress-circular>
          <h3 class="mt-5 mb-3" v-if="problem==null">{{aktualni_stav}}</h3>
          <h3 class="mb-3 mt-3 red--text" v-if="problem!=null">{{problem}}</h3>
          <v-btn color="grey" v-if="problem!=null" flat @click="dialog=false">Zavřít</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Fakturace provizí</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm3 lg2>
                <obdobi v-model="obdobi"></obdobi>
              </v-flex>
              <v-flex xs12 sm3 lg2>
                <v-text-field
                  label="Hledat dle jména"
                  class="mx-2"
                  v-model="search"
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 lg3>
                <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="mx-2 d-flex grow">
                  <v-text-field
                    label="Datum"
                    v-model="datum"
                    slot="activator"
                    readonly
                    class="mx-0"
                    :class="{'mx-2': $vuetify.breakpoint.smAndUp}" clearable
                  ></v-text-field>
                  <v-card>
                    <v-card-text>
                      <DateRangePicker
                        :options="dateRangeOptions"
                        @input="onDateRangeChange"
                        :labels="labels"
                        @close="menu=false"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1 mt-2" v-if="!loading">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                :loading="loadingTable"
              >
                <template slot="items" slot-scope="props">
                  <td>{{props.item.mesic}}/{{props.item.rok}}</td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby_razeni }}
                    </router-link>
                  </td>
                  <td class="text-xs-right">{{ props.item.celkem_castka | formatMoney }} Kč</td>
                  <td class="text-xs-right">{{ props.item.celkem_kredity | formatDouble }}</td>
                  <td class="text-xs-right">{{ 0 | formatMoney }}</td>
                  <td class="text-xs-right">{{ props.item.vlastni_castka | formatMoney }} Kč</td>
                  <td class="text-xs-right">{{ props.item.skupinova_castka | formatMoney }} Kč</td>
                  <!-- <td class="text-xs-right">{{ 0 | formatMoney }}</td> -->
                  <td class="text-xs-right">{{ props.item.vlastni_kredity | formatDouble }}</td>
                  <td class="text-xs-right">{{ props.item.skupinove_kredity | formatDouble }}</td>
                  <td>{{ props.item.pozice }}</td>
                  <td class="text-xs-right">{{ props.item.hodnota_kreditu }} Kč</td>
                  <td class="text-xs-right">{{ props.item.prevedeno_minule_obdobi | formatMoney }} Kč</td>
                  <td class="text-xs-left">
                    <span v-if="props.item.prevedeno" class="bold">Převedeno</span>
                    <span v-else-if="props.item.faktura_odsouhlasena && !props.item.faktura_schvalovani && props.item.obdobi_ukonceno" class="bold green--text">Odsouhlaseno</span>
                    <span v-else-if="!props.item.faktura_odsouhlasena && !props.item.faktura_schvalovani && props.item.obdobi_ukonceno" class="bold red--text">Neodsouhlaseno</span>
                    <span v-else-if="props.item.faktura_schvalovani && props.item.obdobi_ukonceno">Probíhá schvalování</span>
                    <span v-else-if="!props.item.obdobi_ukonceno">Období neukončeno</span>
                  </td>
                  <td class="text-xs-right">
                    <v-btn color="green" dark class="elevation-0" target="_blank" @click="informovatSpolupracovnika(props.item)" v-if="props.item.mozno_informovat">
                      <v-icon small class="mr-2">send</v-icon> Informovat spolupracovníka
                    </v-btn>
                    <v-btn color="orange" dark class="elevation-0" target="_blank" @click="prevestObdobiSpolupracovnika(props.item)" v-if="props.item.mozno_informovat || props.item.mozno_prevest">
                      <v-icon small class="mr-2">send</v-icon> Převést období
                    </v-btn>
                    <v-btn color="primary" class="elevation-0" :to="{ path: '/fakturace-provizi/' + props.item.id }" target="_blank">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                    <!-- <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">reply</v-icon> K převodu
                    </v-btn> -->
                    <!-- <v-btn color="primary" class="elevation-0"> -->
                    <a :href="$salesmanInvoicesBaseUrl + props.item.fa_s3_nazev" v-if="props.item.fa_s3_nazev != null" target="_blank">
                      <v-btn color="primary" depressed>
                        <v-icon class="mr-2">cloud_download</v-icon> Stáhnout fakturu
                      </v-btn>
                    </a>
                    <v-btn color="grey lighten-3" v-else depressed @click="uploadInvoiceClick(props.item)"><v-icon class="mr-2">cloud_upload</v-icon> Nahrát fakturu</v-btn>
                    <v-menu bottom left offset-y>
                      <v-btn color="transparent" dark slot="activator" fab depressed class="black--text ma-0 mt-1" small><v-icon>more_vert</v-icon></v-btn>
                      <v-list>
                        <v-list-tile @click="uploadInvoiceClick(props.item)" v-if="props.item.fa_s3_nazev != null">
                          <v-list-tile-title>Znovu nahrát fakturu</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="uploadInvoiceClickNeedApproval(props.item)">
                          <v-list-tile-title>Nahrát fakturu k odsouhlasení</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <!-- <v-icon small class="mr-2">payment</v-icon> Fakturovat</v-btn> -->
                  </td>
                </template>
                <template slot="footer">
                  <tr>
                    <td colspan="2" class="text-xs-left" style="padding-left: 15px;"><strong>Celkem:</strong></td>
                    <td class="text-xs-right" style="padding-right: 15px;">
                      {{sum.celkem_castka | formatMoney}} Kč
                    </td>
                    <td class="text-xs-right">

                    </td>
                    <td></td>
                    <td class="text-xs-right" style="padding-right: 15px;">
                      {{sum.vlastni_castka | formatMoney}} Kč
                    </td>
                    <td class="text-xs-right" style="padding-right: 15px;">
                      {{sum.skupinova_castka | formatMoney}} Kč
                    </td>
                    <!-- <td></td> -->
                    <td class="text-xs-right" style="padding-right: 15px;">
                      {{sum.vlastni_kredity | formatMoney}} kr.
                    </td>
                    <td class="text-xs-right">

                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Base from '@/pages/Base'
import Loader from '@/components/Loader'
import DateRangePicker from '@/components/DateRange';
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      headers: [
        { text: 'Období', value: 'id', sortable: true },
        { text: 'Spolupracovník', value: 'osoba' },
        { text: 'Provize celkem', value: 'celkem_castka', align: 'right' },
        { text: 'Kredity celkem', value: 'celkem_kredity', align: 'right' },
        { text: 'Převedené provize', value: 'predane_provize', align: 'right', sortable: false },
        { text: 'Vlastní provize', value: 'vlastni_castka', align: 'right' },
        { text: 'Skupinová provize', value: 'skupinova_castka', align: 'right' },
        // { text: 'Provize za kancelář', value: 'provize_kancelar', align: 'right', sortable: false },
        { text: 'Vlastní kredity', value: 'vlastni_kredity', align: 'right' },
        { text: 'Skupinové kredity', value: 'skupinove_kredity', align: 'right' },
        { text: 'Stupeň kariéry', value: 'pozice' },
        { text: 'Odměna za kredit ', value: 'hodnota_kreditu', align: 'right' },
        { text: 'Převedeno z předcozích měsíců ', value: 'prevedeno_minule_obdobi', align: 'right' },
        { text: 'Stav ', value: 'faktura_odsouhlasena', sortable: false, align: 'left' },
        { text: 'Akce', value: null, sortable: false, align: 'right' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: "id",
        totalItems: 0
      },
      obdobi: null,
      dialogUploadDocument: false,
      dropzoneOptions: null,
      activeItem: null,
      uploadedItem: null,
      uploading: false,
      dialog: false,
      problem: null,
      aktualni_stav: null,
      success: false,
      datum_od: null,
      datum_do: null,
      dateRangeOptions: {
        startDate: moment().subtract("days", 7).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'DD.MM.YYYY',
        presets: [
          {
            label: 'Dnes',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento měsíc',
            range: [
              moment().startOf("month").format('YYYY-MM-DD'),
              moment().endOf("month").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý měsíc',
            range: [
              moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
              moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento rok',
            range: [
              moment().startOf("year").format('YYYY-MM-DD'),
              moment().endOf("year").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý rok',
            range: [
              moment().subtract("years", 1).startOf("year").format('YYYY-MM-DD'),
              moment().subtract("years", 1).endOf("year").format('YYYY-MM-DD'),
            ],
          }
        ],
      },
      range: [],
      labels: {
        start: "Začátek",
        end: "Konec"
      },
      menu: false,
      datum: null,
      sum: {}
    }
  },
  created () {
    var $this = this;
    this.dropzoneOptions = {
      url: window.API.$api_url+"uploader/invoice",
      clickable: true,
      autoProcessQueue: true,
      uploadMultiple: false,
      parallelUploads: 1,
      addRemoveLinks: true,
      previewsContainer: "#dropzone-preview",
      headers: {
        "AuthToken": window.api.$cookies.get("cc_com_token")
      },
      init: function() {
        this.on("addedfile", function(a, b, c) {
          $this.uploading = true;
        }.bind(this));
        this.on("success", function(a, b, c) {
          if (b.uploaded) {
            $this.uploadedItem = b;
            /*$this.updateItem.dokumenty.push({
              id: b.id,
              nazev: a.name,
              s3_nazev: b.s3_name,
              u: true
            });*/
            $this.putInvoice($this, (state) => {
              if (state) {
                $this.dialogUploadDocument = false;
                $this.activeItem.fa_s3_nazev = b.s3_name;
              }
              $this.uploading = false;
            });
          }
        }.bind(this));
      }
    };
  },
  mounted: function() {
    window.MenuListener.show();
    //this.load();
  },
  watch: {
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    },
    obdobi (v) {
      if (v != null)
        this.load();
    },
    search () {
      this.queryList();
    },
    datum_od () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    },
    datum_do () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    }
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("fakturace-provizi/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        obdobi: this.datum_od == null ? this.obdobi : null,
        datum_od: this.datum_od,
        datum_do: this.datum_do != null ? parseInt(this.datum_do) - 86400 : 0
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.sum = body.sum;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    uploadInvoiceClick(item) {
      this.activeItem = item;
      this.invoiceNeedsApproval = false;
      this.dialogUploadDocument = true;
    },
    uploadInvoiceClickNeedApproval(item) {
      this.activeItem = item;
      this.invoiceNeedsApproval = true;
      this.dialogUploadDocument = true;
    },
    putInvoice($this, f) {
      window.API.put(this.invoiceNeedsApproval ? ("fakturace-provizi/" + $this.activeItem.id + "/faktura-k-odsouhlaseni") : ("fakturace-provizi/" + $this.activeItem.id + "/faktura"), {
        soubor_id: $this.uploadedItem.id
      }).then(function(body) {
        if (typeof f === "function")
          f(body.updated);
        if (this.invoiceNeedsApproval) {
          $this.activeItem.faktura_schvalovani = true;
          $this.activeItem.obdobi_ukonceno = true;
        }
        else {
          $this.activeItem.faktura_schvalovani = false;
          $this.activeItem.faktura_odsouhlasena = true;
          $this.activeItem.obdobi_ukonceno = true;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    informovatSpolupracovnika (v) {
      this.dialog = true;
      this.problem = null;
      this.aktualni_stav = "Probíhá informování spolupracovníka";
      this.success = false;
      window.API.post("fakturace-provizi/informovat", {
        id: v.osoba.id
      }).then(function(body) {
        if (body.updated) {
          this.load(() => {
            this.aktualni_stav = "Spolupracovník informován"
            this.success = true;
            setTimeout(() => {
              this.dialog = false;
            }, 1000);
          });
        }
        else {
          this.problem = "Nelze informovat spolupracovníka";
        }
      }.bind(this)).catch(function(err) {
        this.problem = "Nelze informovat spolupracovníka";
        console.log(err);
      }.bind(this));
    },
    prevestObdobiSpolupracovnika (v) {
      this.dialog = true;
      this.problem = null;
      this.aktualni_stav = "Probíhá převádění období";
      this.success = false;
      window.API.post("fakturace-provizi/prevest", {
        id: v.osoba.id
      }).then(function(body) {
        if (body.updated) {
          this.load(() => {
            this.aktualni_stav = "Období převedeno"
            this.success = true;
            setTimeout(() => {
              this.dialog = false;
            }, 1000);
          });
        }
        else {
          this.problem = "Období nelze převést";
        }
      }.bind(this)).catch(function(err) {
        this.problem = "Období nelze převést";
        console.log(err);
      }.bind(this));
    },
    onDateRangeChange (e) {
      this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
      this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
      this.obdobi = null;
      this.load();
    }
  },
  components: {
    DateRangePicker, vueDropzone: vue2Dropzone
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Fakturace/FakturaceProvizi.vue